/** Short reminder — shown once at top of each section panel. */
export default function AdminSteps() {
  return (
    <div className="admin-steps" role="note">
      <span className="admin-steps__item">
        <span className="admin-steps__num">1</span> Find item &amp; click <strong>Edit</strong>
      </span>
      <span className="admin-steps__item">
        <span className="admin-steps__num">2</span> Save in the window
      </span>
      <span className="admin-steps__item">
        <span className="admin-steps__num">3</span> Click <strong>Publish changes</strong> (top right)
      </span>
    </div>
  );
}
